import { useState } from "react";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import { useListarHistoricoGachapon } from "../../../../Hooks/Admin";

// Puedes ajustar estos campos según la estructura real del histórico
const columns = [
  { title: "ID", dataIndex: "idGachapon", key: "idGachapon" },
  { title: "Usuario", dataIndex: "nombreUsuario", key: "nombreUsuario" },
  { title: "Código Gacha", dataIndex: "codigoGacha", key: "codigoGacha" },
  { title: "Código Único", dataIndex: "codigoUnico", key: "codigoUnico" },
  { title: "Fecha Creación", dataIndex: "fechaCreacionRegistro", key: "fechaCreacionRegistro" },
  { title: "Fecha Caducidad", dataIndex: "fechaCaducidad", key: "fechaCaducidad" },
  { title: "Reclamado", dataIndex: "reclamado", key: "reclamado", render: (val) => val ? "Sí" : "No" },
  { title: "Pokémon Registrados", dataIndex: "pokemonRegistrados", key: "pokemonRegistrados", render: (val) => {
    try {
      const arr = JSON.parse(val);
      return arr.map(p => `ID: ${p.idPokemon} (Rareza: ${p.rareza})`).join(", ");
    } catch {
      return val;
    }
  } },
];



const camposFilter = {
  title: "Codigos Objetos",
  campos: [
   {
      name: "usuario",
      type: "text",
      placeholder: "Usuario",
      rules: [
        {
          max: 45,
        },
      ],
    },
  ],
};
 
export const HistoricoGachapon = () => {
  // Usar el hook como en Gacha
  const queryListarHistorico = useListarHistoricoGachapon();

  return (
    <CustomTable
      tituloTabla="Historico Gachapon"
      camposFilter={camposFilter}
      columns={columns}
      //camposFormularioModal={campos}
      queryListar={useListarHistoricoGachapon}
     
    />
  );
};
